import { Suspense } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';

import NewClientLayout from 'src/layouts/new-client/NewClientLayout';

import { getMainRoutes } from 'src/routes/sections/main';
import AdminRoutesLazy from 'src/routes/sections/AdminRoutesLazy';

import ClientStoreProvider from 'src/redux/client/ClientStoreProvider';
import { SplashScreen } from 'src/components/loading-screen';
import LiquidityProviderRoutesLazy from 'src/routes/sections/LProuteslazy';
import NewDesign from 'src/pages/NewDesign';

import { lazyRetry } from 'src/utils/lazyRetry';
import ClientTransactions from 'src/pages/ClientTransactions';
import { ClientTransactionStatus } from 'src/components/Transaction-status-card';

const Page404 = lazyRetry(() => import('src/pages/404'));

const Router = () => {
  return useRoutes([
    {
      element: (
        <ClientStoreProvider>
          <Outlet />
        </ClientStoreProvider>
      ),
      children: [
        {
          element: (
            <NewClientLayout>
              <Suspense fallback={<SplashScreen />}>
                <Outlet />
              </Suspense>
            </NewClientLayout>
          ),
          children: [
            {
              path: '/',
              element: <NewDesign />,
            },
            {
              path: '/transactions',
              element: <ClientTransactions />,
            },
            {
              path: '/transaction/:id',
              element: <ClientTransactionStatus />,
            },
          ],
        },
        ...getMainRoutes(),
      ],
    },

    {
      path: 'admin/*',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <AdminRoutesLazy />
        </Suspense>
      ),
    },

    {
      path: 'lp/*',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <LiquidityProviderRoutesLazy />
        </Suspense>
      ),
    },

    {
      path: '*',
      element: <Page404 />,
    },
  ]);
};

export default Router;
